import { render, staticRenderFns } from "./LvTabs.vue?vue&type=template&id=2f3e6444"
import script from "./LvTabs.vue?vue&type=script&lang=js"
export * from "./LvTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports